import EFPicture from 'elem/compCommon/EFPicture';
import { Collapse } from 'antd';
import { useMemo } from 'react';
import XBoost from 'elem/SVGIcon/LoadShedding/XBoost';
import LFP from 'elem/SVGIcon/LoadShedding/LFP';
import BMS from 'elem/SVGIcon/LoadShedding/BMS';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function J() {
    const { useLang, useState, useEffect } = useGlobal();
    const { t } = useLang('loadshedding');
    const [active, setActive] = useState(0);
    const lists: any = [
        {
            title: t('secJ_list1_title'),
            desc: t('secJ_list1_desc'),
            icons: [
                {
                    icon: <XBoost className="original" />,
                    text: t('secJ_list1_icon1'),
                },
            ],
        },
        {
            title: t('secJ_list2_title'),
            desc: t('secJ_list2_desc'),
            icons: [
                {
                    icon: <LFP />,
                    text: t('secJ_list2_icon1'),
                },
            ],
        },
        {
            title: t('secJ_list3_title'),
            desc: t('secJ_list3_desc'),
            icons: [
                {
                    icon: <BMS />,
                    text: t('secJ_list3_icon1'),
                },
            ],
        },
    ];

    const renderImg = useMemo(
        () => (
            <EFPicture
                src={`/responsive/picture/load-shedding/7_${Number(active || 0) + 1}.jpg`}
                srcPad={`/responsive/picture/load-shedding/7_${Number(active || 0) + 1}_768.jpg`}
                srcMobile={`/responsive/picture/load-shedding/7_${Number(active || 0) + 1}_768.jpg`}
                alt={t('secJ_title')}
            />
        ),
        [active],
    );

    return (
        <div id="load-shedding-J" className={`load-shedding-J ${css['load-shedding-J']}`}>
            <div className="text-box">
                <h2 className="title">{t('secJ_title')}</h2>
            </div>
            <div className="box-container">
                <div className="card-box">
                    <div className="card-inner">
                        <Collapse
                            ghost={true}
                            className="collapse-lists"
                            defaultActiveKey={0}
                            onChange={setActive}
                            accordion={true}
                            expandIcon={({ isActive }: any) => {
                                return (
                                    !isActive && (
                                        <svg
                                            className="collapse-icon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="25"
                                            height="25"
                                            viewBox="0 0 25 25"
                                            fill="none"
                                        >
                                            <path
                                                d="M12.5 22.5C18.0228 22.5 22.5 18.0228 22.5 12.5C22.5 6.97715 18.0228 2.5 12.5 2.5C6.97715 2.5 2.5 6.97715 2.5 12.5C2.5 18.0228 6.97715 22.5 12.5 22.5Z"
                                                stroke="#757575"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M8.5 11.5L12.5 15.5L16.5 11.5"
                                                stroke="#757575"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    )
                                );
                            }}
                            expandIconPosition="right"
                        >
                            {lists?.map((list: any, k: number) => (
                                <Collapse.Panel className="list-title" key={k} header={list.title}>
                                    <div className="list-img">{renderImg}</div>
                                    <p className="list-desc">{list.desc}</p>
                                    <ul className="list-icons">
                                        {list?.icons?.map((icon: any, m: number) => (
                                            <li className="list-icon" key={`${k}_${m}`}>
                                                <div className="icon-box">{icon?.icon}</div>
                                                <p className="icon-text">{icon?.text}</p>
                                            </li>
                                        ))}
                                    </ul>
                                </Collapse.Panel>
                            ))}
                        </Collapse>
                    </div>
                </div>
                <div className="img-box">{renderImg}</div>
            </div>
        </div>
    );
}
